import Button from "../../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import axios from "axios";
import errorParser from "../../../../../components/ErrorParser/ErrorParser";
import LoadingComp from "../../../../../components/elements/LoadingComp/LoadingComp";
import AddFoodMenuForm from "./AddFoodMenuForm";

export default function AddFoodMenu() {

    const intl = useIntl();
    const navigate = useNavigate()
    const jwt = localStorage.getItem('jwt')
    let params = useParams();
    const emptyItem = {
        'title': '',
        'price': 0,
        'products': []
    }

    const [title, setTitle] = useState('')
    const [price, setPrice] = useState(0)
    const [addition, setAddition] = useState(0)
    const [cost, setCost] = useState(0)
    const [costPerMenu, setCostPerMenu] = useState(false)
    const [pricePerMenu, setPricePerMenu] = useState(false)

    const [eventType, setEventType] = useState('wedding')
    const [eventTypes, setEventTypes] = useState([])
    const [items, setItems] = useState([emptyItem])
    const [vat, setVat] = useState(0)
    const [loading, setLoading] = useState(true)
    const [vats, setVats] = useState([])
    const [productsOptions, setProductsOptions] = useState([])

    const [saveLoading, setSaveLoading] = useState(false)
    const {context} = useOutletContext()
    useEffect(() => {
        getEventTypes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getEventTypes = async () => {
        axios.get(process.env.REACT_APP_API + '/event-types' , {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let temp = []
                for (let i=0; i < response.data.length; i++){
                    temp.push({
                        value: response.data[i].id,
                        label: intl.formatMessage({id: 'general.event_type.' + response.data[i].title})
                    })
                }
                setEventType(temp.map(item => item.value))
                setEventTypes(temp)
                getVats()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    useEffect(() => {
        if (parseInt(params.id) !== 0) {
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API + '/food-menus/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        }).then(async (response) => {
            if (response.data) {
                setTitle(response.data.title)
                setAddition(parseFloat(100 * (response.data.price - response.data.cost)/response.data.cost).toFixed(2))
                setPrice(response.data.price)
                setCost(response.data.cost)
                setCostPerMenu(response.data.cost_per_menu)
                setPricePerMenu(response.data.price_per_menu)
                setEventType(response.data.event_type)
                setItems(response.data.items)
            }
        })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getVats = async () => {
        axios.get(process.env.REACT_APP_API + '/vats', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let options = []
                response.data.forEach((item) => {
                    options.push({
                        value: item.id,
                        label: item.value,
                    })
                })
                setVats(options)
                getProductsOptions()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getProductsOptions = async () => {
        axios.post(process.env.REACT_APP_API + '/menu-products/list/0', {},{
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let options = []
                response.data.products.filter(item => item.type !== 'ingredients' && item.category === 'food').forEach((item) => {
                    options.push({
                        value: item.id,
                        label: item.title,
                        price: item.price,
                        cost: item.production_price,
                        unit: item.unit,
                    })
                })
                setProductsOptions(options)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const save = async (e) => {
        e.preventDefault(); if (vat === 0) {
            toast.error(intl.formatMessage({id: "errors.please_fill_all_fields"}))
            return
        }

        setSaveLoading(true)
        let payload = {
            title: title,
            price: price,
            vat,
            cost,
            event_types: eventType,
            items: items,
            cost_per_menu: costPerMenu,
            price_per_menu: pricePerMenu,
        }

        await axios.post(process.env.REACT_APP_API + '/food-menus', payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                context.setContentUpdated(false)
                navigate(-1)
            })
            .catch(err => {
                errorParser(err, intl)
            })


        setSaveLoading(false)
    }
    if (loading) {
        return <LoadingComp/>
    }
    return (
        <div className="card">

            <div className={"header"}><p>{intl.formatMessage({id: 'menus.add_food_menu'})}</p></div>

            <form onSubmit={(e) => save(e)}>
                <div className={"content"}>
                    <AddFoodMenuForm
                        items={items}
                        setItems={setItems}
                        price={price}
                        setPrice={setPrice}
                        cost={cost}
                        setCost={setCost}
                        title={title}
                        setTitle={setTitle}
                        vat={vat}
                        setVat={setVat}
                        eventTypes={eventTypes}
                        eventType={eventType}
                        setEventType={setEventType}
                        context={context}
                        addition={addition}
                        setAddition={setAddition}
                        costPerMenu={costPerMenu}
                        setCostPerMenu={setCostPerMenu}
                        pricePerMenu={pricePerMenu}
                        setPricePerMenu={setPricePerMenu}
                        vats={vats}
                        productsOptions={productsOptions}
                    />
                </div>

                <div className={"footer"}>
                    <div className={"row"}>
                        <div className={"col-12 col-md-6"}>
                            <Button
                                className={"btn-light mt-2"}
                                icon={"fa-solid fa-chevron-left"}
                                value={intl.formatMessage({id: 'general.buttons.back'})}
                                onClick={() => {
                                    context.setLeavePage(true)
                                    context.setNextLink('/menus/food-menus')
                                }}
                            />
                        </div>
                        <div className={"col-12 col-md-6 d-flex"}>
                            <Button
                                className={"btn-secondary mt-2 ms-auto"}
                                icon={"fa-solid fa-plus"}
                                value={intl.formatMessage({id: 'general.buttons.add'})}
                                disabled={saveLoading}
                                loading={saveLoading}
                                type={'submit'}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

